import type { Rule } from "antd/lib/form";
import i18n from "i18next";

import type { ValidationRuleParams } from "../../../types/types";

export const getNumberMaxRule = (validationRuleParams: ValidationRuleParams) => {
    if (!validationRuleParams || validationRuleParams.length === 0) {
        return undefined;
    }

    const MAX_VALUE_ARG = 0;
    const maxNumber = validationRuleParams[MAX_VALUE_ARG] as number;

    return {
        validator: (_, value) => {
            if (value === undefined || value === null || value === "") {
                return Promise.resolve();
            }

            const numberAsString = String(value).trim();

            const number = Number(numberAsString);
            if (!Number.isSafeInteger(number)) {
                return Promise.reject(i18n.t("common.input.invalidNumber.error"));
            }

            if (number <= maxNumber) {
                return Promise.resolve();
            }
            return Promise.reject(i18n.t("common.input.exceededValueNumber.error", { maxNumber }));
        },
    } as Rule;
};
